module.exports = __webpack_public_path__ + "static/media/ThumbnailStill02.e095908f.png";